import { memo } from 'react';
import { Field } from 'react-final-form';

import { validateRequiredFn } from 'shared/functions';
import { FileUploadField } from 'shared/ui/FileUploadField';
import { Input } from 'shared/ui/Input';

import { dropzoneContentType } from 'components/Dropzone';

import type { UploadFileBaseOptions, UploadFileBaseValues } from '../types';

export interface FormUploadCvValues extends UploadFileBaseValues {
  parse?: boolean;
}

export interface FormUploadCvProps extends UploadFileBaseOptions<FormUploadCvValues> {
  canParse?: boolean;
  handleAcceptFiles?: (file: []) => void;
}

const accept = {
  'text/plain': ['.txt'],
  'text/html': ['.htm', '.html'],
  'application/pdf': ['.pdf'],
  'application/rtf': ['.rtf'],
  'application/msword': ['.doc', '.dot'],
  'application/vnd.oasis.opendocument.text': ['.odt'],

  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

const getUploadFileLabel = () => <div className="text-primary margin-top">{translate('Upload a file')}</div>;

const getUploadFileDescription = () =>
  translate('Only .doc, .docx, .dot, .rtf, .pdf, .odt, .txt, .htm, .html; 5Mb maximum.');

const FormUploadFile = ({ initialValues, canParse, handleAcceptFiles }: FormUploadCvProps) => (
  <div>
    <div className="row">
      <div className="col-xs-12">
        <Field
          name="files"
          maxFiles={1}
          minSize={10}
          accept={accept}
          maxSize={5 * 1024 * 1024}
          label={getUploadFileLabel()}
          valueByDefault={initialValues.files}
          contentType={dropzoneContentType.base64String}
          description={getUploadFileDescription()}
          handleAcceptFiles={handleAcceptFiles}
          component={FileUploadField}
          validate={validateRequiredFn}
        />
      </div>
    </div>
    {canParse && (
      <div className="row">
        <div className="col-xs-12">
          <label>
            <Field type="checkbox" name="parse" formClass="inline-div" valueClass="inline-div" component={Input} />
            &nbsp;{translate('Parse CV')}
          </label>
        </div>
      </div>
    )}
  </div>
);

// eslint-disable-next-line import/no-default-export
export default memo(FormUploadFile);
